import { useContext, useEffect, useMemo, useState, useTransition } from "react";

import { RIDE_AREA_TITLES_DELIMITER } from "@ryde/shared";

import { DropdownSourceContext } from "../../contexts";

export const useAreaTitles = (areaIds: number[]) => {
  const { getDropdownLabels } = useContext(DropdownSourceContext);
  const [areaTitles, setAreaTitles] = useState<string[]>([]);
  const [, startTransition] = useTransition();
  useEffect(() => {
    const fetchTitle = async (): Promise<void> => {
      if (!areaIds?.length) {
        setAreaTitles([]);
      }

      const areaTitlesFetched = await getDropdownLabels("area", areaIds);
      setAreaTitles(areaTitlesFetched || []);
    };

    startTransition(() => {
      fetchTitle();
    });
  }, [areaIds, getDropdownLabels]);

  const areaTitlesCombined = useMemo(() => {
    if (!areaTitles?.length) {
      return "";
    }

    return areaTitles.join(RIDE_AREA_TITLES_DELIMITER);
  }, [areaTitles]);

  return { areaTitles, areaTitlesCombined };
};
